import {
  getFromLocalStorage,
  removeFromLocalStorage,
  saveToLocalStorage,
} from '@/helpers/local-storage';

export const LOCAL_STORAGE_USER_SELECTED_JOB_KEY = 'lastSelectedJob';
export const LOCAL_STORAGE_USER_SELECTED_HEADHUNTER_KEY = 'lastHeadhunterCid';

// Job Selection
export const saveUserSelectedJob = () => {
  saveToLocalStorage(LOCAL_STORAGE_USER_SELECTED_JOB_KEY, true);
};

export const getUserSelectedJob = () => getFromLocalStorage(LOCAL_STORAGE_USER_SELECTED_JOB_KEY);

export const removeUserSelectedJob = () => {
  removeFromLocalStorage(LOCAL_STORAGE_USER_SELECTED_JOB_KEY);
};

// Headhunter Selection
export const saveUserSelectedHeadhunter = () => {
  saveToLocalStorage(LOCAL_STORAGE_USER_SELECTED_HEADHUNTER_KEY, true);
};

export const getUserSelectedHeadhunter = () => getFromLocalStorage(LOCAL_STORAGE_USER_SELECTED_HEADHUNTER_KEY);

export const removeUserSelectedHeadhunter = () => {
  removeFromLocalStorage(LOCAL_STORAGE_USER_SELECTED_HEADHUNTER_KEY);
};
